/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface UserMini {
  id: string;
  full_name: string;
  email: string;
  avatar_url?: string | null;
}
